module.exports = __webpack_public_path__ + "img/icon_证书_C级赛事@3x.62baf132.png";